import(/* webpackMode: "eager", webpackExports: ["Heading"] */ "/vercel/path0/apps/PublicUI/app/(marketplace)/for-educators/Heading/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/PublicUI/app/(marketplace)/for-educators/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["BookDemoButton"] */ "/vercel/path0/apps/PublicUI/app/components/BookDemoButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DemoVideoDialog"] */ "/vercel/path0/apps/PublicUI/app/components/DemoVideoDialog/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["EducatorSignUpButton"] */ "/vercel/path0/apps/PublicUI/app/components/EducatorSignUpButton/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/PublicUI/components/FAQs/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["GroupedFeatures"] */ "/vercel/path0/apps/PublicUI/components/GroupedFeatures/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/PublicUI/components/ImageWithFallback/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/PublicUI/components/LogosStrip/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/PublicUI/components/TestimonialsCarousel/styles.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/apps/PublicUI/components/Testimonial/styles.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/PublicUI/pages_components/pricing/PricingCards/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["IAmClientProvider"] */ "/vercel/path0/apps/PublicUI/services/IAm/provider/clientProvider/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
